import { render, staticRenderFns } from "./SettingPanel.vue?vue&type=template&id=379d00f6&scoped=true"
import script from "./SettingPanel.vue?vue&type=script&lang=js"
export * from "./SettingPanel.vue?vue&type=script&lang=js"
import style0 from "./SettingPanel.vue?vue&type=style&index=0&id=379d00f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379d00f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('379d00f6')) {
      api.createRecord('379d00f6', component.options)
    } else {
      api.reload('379d00f6', component.options)
    }
    module.hot.accept("./SettingPanel.vue?vue&type=template&id=379d00f6&scoped=true", function () {
      api.rerender('379d00f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/components/SettingPanel.vue"
export default component.exports